import Button from 'components/_UI/Button'
import Fieldset from 'components/_UI/Fieldset'
import Modal from 'components/_UI/Modal'
import Radio from 'components/_UI/Radio'
import Text from 'components/_UI/Text'
import React, { useEffect, useState } from 'react'
import { Gift, User, Users } from 'react-feather'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'
import randomPickerApi from 'api/requests/randomPicker.js'

import { useForm } from 'react-hook-form'
import fieldValidations from 'helpers/fieldValidations'
import breakpoints from 'theme/breakpoints'
import Loader from 'components/_UI/Loader'

import participantsApi from 'api/requests/participants'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'



export default function CreateDrawer({visible, onClose, slug, onSuccess = () => {}}) {
    const [loading, setLoading] = useState(false);
    const [participants, setParticipants] = useState([]);
    const [error, setError] = useState(false)
    
    useEffect(() => {
      getParticipants(slug)
    }, [])
    
     const { 
        register, 
        handleSubmit, 
        setValue, 
        watch,
        formState: { errors } 
    } = useForm({});


    async function getParticipants(slug) {
        setLoading(true)
        try {
            const {data} = await participantsApi.list(slug)
            setParticipants(data?.data)
        } catch (error) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    const selectedAllParticipants = watch("participantsType");
    
    async function createRandomPicker(content) {
        setLoading(true)
        const payload = {
            name: content?.name,
            winners_count: parseInt(content?.quantity),
            scope: content?.participantsType
        }

     
        try {
            await randomPickerApi.create(slug, payload)
            
        
            setError(false)
            onSuccess()
            
        } catch ({response}) {

            setLoading(false)
            
            setError(response?.data?.message)
        } 
    }
  return (
    <Modal isOpen={visible} size='medium' onClose={onClose}>
        {
            loading ? (
                <Loader />
            ) : (
                participants.length > 0 ? (          
                    <>
                        <Text name={'highlight'} >Sorteador de Paricipantes</Text>

                        <ContainerDrawer>
                                
                            <Form onSubmit={handleSubmit(createRandomPicker)}>
                                <ContentInfos>
                                    <Column>
                                    
                                        <Fieldset
                                            label='Nome do Sorteio'
                                            placeholder='Nome do Sorteio'
                                            layout='squired'
                                            register={register}
                                            name={'name'}
                                            validations={fieldValidations.name('nome')}
                                        />
                                        {errors.name?.message && (
                                            <Column>
                                                <Text color={colors.danger} name='small'> {errors.name?.message} </Text>
                                            </Column>
                                        )}
                                    </Column>
                                    <Column>
                                        
                                        <Fieldset
                                            label='Quantos participantes quer sortear?'
                                            inputType='number'
                                            layout='squired'
                                            placeholder='Quantidade'
                                            name='quantity'
                                            register={register}
                                            validations={fieldValidations.quantity('quantidade', 10)}
                                        />
                                        
                                        {errors.quantity?.message && (
                                            <Column>
                                                <Text color={colors.danger} name='small'> {errors.quantity?.message} </Text>
                                            </Column>
                                        )}
                                        <TextMaxPaticipants>Máximo: 10 participantes</TextMaxPaticipants>
                                    </Column>
                                </ContentInfos>
                                
                                <Text type='bold' marginTop={'15px'}> Quem pode ser sorteado?</Text>

                                <Column marginTop={'5px'}>
                                    <CardTypeParticipants selected={selectedAllParticipants === "all" } onClick={() => setValue("participantsType", "all")}>
                                        <input
                                            type="hidden"
                                            {...register("participantsType", { required: "Selecione quem pode ser sorteado" })}
                                        />
                                        <Radio 
                                            marginTop={'0px'}
                                            selected={selectedAllParticipants === "all"}
                                            onSelect={() => setValue("participantsType", "all")}
                                        />
                                    
                                        <ContentCardType >
                                            <Users color={colors.nightLight} size={'20px'}/>
                                            <ContentTexts>
                                                <Text type='bold' paddingBottom={'0px'} marginLeft={'10px'}>Todos os participantes</Text>
                                                <Text paddingBottom={'0px'} marginLeft={'10px'} marginTop={'5px'}>Sortear entre <b>todos</b> os participantes</Text>
                                            </ContentTexts>
                                        </ContentCardType>
                                    </CardTypeParticipants>

                                    <CardTypeParticipants selected={selectedAllParticipants === "checked_in" } margin  onClick={() => setValue("participantsType", "checked_in")}>
                                    
                                        <Radio 
                                            marginTop={'0px'}
                                            selected={selectedAllParticipants === "checked_in"}
                                            onSelect={() => setValue("participantsType", "checked_in")}
                                        />
                                    
                                        <ContentCardType>
                                            <User color={colors.nightLight} size={'20px'}/>
                                            <ContentTexts>
                                                <Text type='bold' paddingBottom={'0px'} marginLeft={'10px'}>Apenas quem fez check-in</Text>
                                                <Text paddingBottom={'0px'} marginLeft={'10px'} marginTop={'5px'}>Sortear entre os participantes que fizeram <b>check-in</b></Text>
                                            </ContentTexts>
                                        </ContentCardType>
                                    </CardTypeParticipants>

                                    {errors.participantsType && (
                                        <Column marginTop={'10px'}>
                                            <Text color={colors.danger} name='small'> {errors.participantsType.message}</Text>
                                        </Column>
                                    )}

                                    <>
                                        <Text marginTop={'10px'} color={colors.danger}>{error}</Text>
                                        <ContentButtons>
                                            <Button
                                                variant={'light'}
                                                category={'roundedBorded'}
                                                onClick={onClose}
                                            >
                                                Cancelar
                                            </Button>
                                            <Button   
                                                
                                                type='submit'
                                                variant='featured'
                                            >
                                                <Gift color={colors.neutral} size={18}  />
                                                <Text marginLeft={'8px'} paddingBottom={'0'} color={colors.neutral}>
                                                    Realizar Sorteio
                                                </Text>
                                            
                                            </Button>
                                        </ContentButtons>
                                    </>
                                </Column>
                            </Form>
                        </ContainerDrawer>
                    </>  
                ) : (
                    <ContentParticipants>
                        <NotResultDashBoard
                            text={
                                <Text name='highlight'>
                                    Não foram encontrados participantes no seu evento até o momento.
                                </Text>
                            }
                            ilustration={'withoutParticipants'}
                            marginTop={'15px'}
                        />
                        <Button 
                            variant={'light'}
                            category={'roundedBorded'}
                            onClick={onClose}
                        >   
                            Fechar
                        </Button>
                    </ContentParticipants>
                )
                      
                )
        }
    </Modal>
  )
}


const ContainerDrawer = styled(Column)`
    align-items: flex-start;
    margin-top: 20px;
`;

const TextMaxPaticipants = styled.p`
    font-size: 11px;
    color: ${colors.night};
`;

const CardTypeParticipants = styled(Row)`
    border: 1px solid ${colors.nightLight};
    border-radius: 8px;
    justify-content: flex-start;
    width: 100%;
    height: 80px;
    padding: 15px;
    cursor: pointer;
    transition: transform 0.3s ease;

    ${({selected}) => selected && `
        border-color: ${colors.secondaryPurple};
    `}

    &:hover {
      transform: scale(1.01);
    }

    ${({margin}) => margin && `
        margin-top: 10px;
    `}   
`;

const ContentCardType = styled(Row)`
   justify-content: flex-start;
  
`;

const ContentTexts = styled(Column)`
    align-items: flex-start;
`;

const ContentButtons = styled(Row)`
    gap: 5px;
    margin-top: 15px;
`;


const Form = styled.form`
    width: 100%;
`;

const ContentInfos = styled(Column)`
    width: 100%;
    @media screen and (min-width: ${breakpoints.md}){
        flex-direction: row;
        gap: 5px;
    }
`;

const ContentWinners = styled(Column)`
    width: 100%;
    height: 250px;
`

const StyledRow = styled(Row)`
    justify-content: center;
`


const ContentParticipants = styled.div`
    & > div {
        flex-direction: column;
        & > div {
            width: 80%;
            min-height: 45px;
        }
    }
   
`